<template>
    <div data-testid="user-show" style="margin: 0 -12px">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col px-0 text-center" style="position: relative">
                        <div style="
                                position: absolute;
                                top: 0;
                                z-index: 999;
                                padding: 15px;
                                width: 100%;
                            ">
                            <div class="row" style="color: #b3b3b3">
                                <div class="col text-start">
                                    <a :href="prev_page" v-if="prev_type == 1" class="link_1" style="font-size: 20px">
                                        <i class="bi bi-chevron-left head-btn"></i>
                                    </a>
                                    <a href="" onclick="history.back(-1);return false;" v-else-if="prev_type == 2"
                                        class="link_1" style="font-size: 20px">
                                        <i class="bi bi-chevron-left head-btn"></i>
                                    </a>
                                    <a href="/auth" v-else-if="prev_type == USER_TYPE.GUEST" class="link_1" style="font-size: 20px">
                                        <i class="bi bi-chevron-left head-btn"></i>
                                    </a>
                                    <a href="/info" class="link_1" style="font-size: 20px" v-else-if="prev_type == 88">
                                        <i class="bi bi-chevron-left head-btn"></i>
                                    </a>
                                    <a :href="'/user/message/' + matching_id" class="link_1" style="font-size: 20px"
                                        v-else-if="user_type == USER_TYPE.MATCHED">
                                        <i class="bi bi-chevron-left head-btn"></i>
                                    </a>
                                    <a href="/search" class="link_1" style="font-size: 20px" v-else>
                                        <i class="bi bi-chevron-left head-btn"></i>
                                    </a>
                                </div>
                                <div class="col text-end" style="font-size: 20px">
                                    <div class="" style="float: right">
                                        <i class="bi bi-three-dots head-btn" @click="is_menu = !is_menu"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-menu text-start" id="modal-menu" v-if="is_menu">
                            <div style="color: #6b4eff; padding: 8px 0" v-if="is_bookmark" @click="setBookmark(0)">
                                お気に入り解除
                            </div>
                            <div style="color: #6b4eff; padding: 8px 0" v-else @click="setBookmark(1)">
                                お気に入りに追加する
                            </div>
                            <div style="color: #ff6d6d; padding: 8px 0" v-if="is_block" @click="setPenalty('block', 0)">
                                ブロック解除
                            </div>
                            <div style="color: #ff6d6d; padding: 8px 0" v-else @click="setPenalty('block', 1)">
                                ブロックする
                            </div>
                            <div style="color: #ff6d6d; padding: 8px 0" v-if="is_penalty"
                                @click="setPenalty('report', 0)">
                                通報解除
                            </div>
                            <div style="color: #ff6d6d; padding: 8px 0" v-else @click="
                                (is_page_penalty = true), (is_menu = false)
                                ">
                                通報する
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" style="height: 100%" v-if="is_page_init">
            <div class="row" style="height: 100%">
                <div class="col" style="height: 100%">
                    <div class="text-center" style="height: 100%">
                        <div class="spinner-grow" style="margin-top: 300px; color: #e7e7ff">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 凍結されたユーザーの表示 -->
        <div class="container" v-else-if="is_user_suspended" style="padding-top: 100px;">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="text-center suspended-container">
                        <div class="suspended-image">
                            <img src="/images/error/not_allowed.png" width="128" alt="not_allowed" />
                        </div>
                        <h4 class="suspended-heading">このアカウントは利用停止されました</h4>
                        <p class="suspended-reason">
                            このアカウントは現在利用停止されています。他のユーザーからの通報が一定数を超えたため、安全管理の観点から利用を停止しております。
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- ブロック・通報関係にあるユーザーの表示 -->
        <div class="container" v-else-if="is_profile_restricted" data-testid="restricted-user-page"
            style="padding-top: 100px;">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="text-center suspended-container">
                        <div class="suspended-image">
                            <img src="/images/error/not_allowed.png" width="128" alt="not_allowed" />
                        </div>
                        <h4 class="suspended-heading">
                            お相手のプロフィールを表示することができません
                        </h4>
                        <a href="/search" class="btn btn-primary">検索へ戻る</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" data-testid="user-show-container" v-else>
            <div class="container">
                <div class="row" style="padding-top: 70px">
                    <div class="col-2 text-center"></div>
                    <div class="col text-center">
                        <img class="img-main-luna" src="/images/icon_user.png" style="width: 100%; z-index: 99"
                            v-if="main_icon == null" />
                        <img class="img-main-luna" src="/images/icon_user.png" style="width: 100%; z-index: 99"
                            v-else-if="main_icon == ''" />
                        <img class="img-main-luna" :src="main_icon" style="width: 100%; z-index: 99" v-else />
                        <div style="
                                margin-top: -20px;
                                z-index: 999;
                                position: relative;
                            ">
                            <div class="row justify-content-center px-0">
                                <div class="col-2 px-0" v-for="(icon, index) in icon_list" :key="index">
                                    <div style="padding: 1px">
                                        <img :src="icon" style="
                                                width: 100%;
                                                border-radius: 10px;
                                                z-index: 999;
                                            " v-if="icon != ''" v-bind:class="[
                                                tap == index ? 'filter' : '',
                                            ]" @click="chengeIcon(index)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 text-center"></div>
                </div>


                
                <!-- プレミアムメッセージ -->
                <div v-if="premiumMessage" class="premium-message">
                    {{ premiumMessage }}
                </div>
                <!-- メッセージ付きいいね -->
                <div v-if="
                    !premiumMessage &&
                    matching_comment_to_me &&
                    (user_type == USER_TYPE.RECEIVED_LIKE || user_type == USER_TYPE.SKIPPED)
                " class="container d-flex justify-content-center align-items-center">
                    <div class="comment-bubble">
                        <p>{{ matching_comment_to_me }}</p>
                    </div>
                </div>
                <div class="row" v-if="user.comment != '' && user.comment != null">
                    <div class="col px-0">
                        <!-- prettier-ignore -->
                        <p class="comment-top">{{ user.comment }}</p>
                        <br />
                    </div>
                </div>
                <div class="row" style="padding-top: 40px">
                    <div class="col-10">
                        <div style="font-size: 20px; color: #6b4eff">
                            {{ user.name }}
                        </div>
                        <small style="font-size: 10px">
                            <div>
                                <span style="">
                                    {{ sex_list[user.sex] }}｜
                                </span>
                                <span style="" v-if="user.age_view">
                                    {{ user.age }}｜
                                </span>
                                <span style="" v-else> 秘密｜ </span>
                                <span style="">
                                    {{ area_list[user.area] }}｜
                                </span>
                                <span style="color: #999">
                                    Luna最終ログイン・{{
                                        user.last_login_at | loginStatus
                                    }}
                                </span>
                            </div>
                        </small>
                    </div>
                    <div class="col">
                        <div v-if="user.can_use_all_features_male">
                            <img src="/images/Group12769.png" style="width: 100%" />
                        </div>
                        <div v-if="user.is_ambassador">
                            <img src="/images/Group12901.png" style="width: 100%" />
                        </div>
                    </div>
                </div>
                <br />
                <div class="row" style="background: #e7e7ff">
                    <div class="col" style="padding-top: 10px; padding-bottom: 10px">
                        <b style="color: #000">探してる関係性</b>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px">
                    <div class="col">
                        <div style="overflow: hidden">
                            <div style="padding-top: 10px">
                                <div :class="is_relationship_list_1
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    友達
                                </div>
                                <div :class="is_relationship_list_2
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    恋愛相手
                                </div>
                                <div :class="is_relationship_list_3
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    一時的なプレイの関係
                                </div>
                                <div :class="is_relationship_list_4
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    SMパートナー
                                </div>
                                <div :class="is_relationship_list_5
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    主従関係
                                </div>
                                <div :class="is_relationship_list_6
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    緊縛パートナー
                                </div>
                                <div :class="is_relationship_list_7
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    ディシスパのパートナー
                                </div>
                                <div :class="is_relationship_list_8
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    ぐりぐらのパートナー
                                </div>
                                <div :class="is_relationship_list_9
                                    ? 'item-line-on'
                                    : 'item-line-off'
                                    ">
                                    SM婚まで考えた関係
                                </div>
                            </div>
                        </div>
                        <div style="padding: 20px 0">
                            <div style="color: #6b4eff; font-size: 11px">
                                <i class="bi bi-exclamation-circle-fill"></i>相性の相違が起こりやすい項目です
                            </div>
                            <div style="color: #777; font-size: 11px">
                                ブロック対象の70%以上はプロフィールを読まずに適当にいいねをしています。<b style="color: #000">しっかりと読んだ上でいいね！を押しましょう。</b>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="background: #e7e7ff">
                    <div class="col" style="padding-top: 10px; padding-bottom: 10px">
                        <b style="color: #000">好みのカード</b>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px">
                    <div class="col">
                        <div class="item-box">
                            <div class="row">
                                <div class="col">
                                    <b>あなたと共通のカード</b>
                                    <div style="color: #6b4eff">
                                        <span style="font-size: 30px">{{
                                            card_count
                                        }}</span><small>こ</small>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="d-flex flex-row">
                                        <div class="" style="width: 50%">
                                            <img :src="user.icon_url" class="rounded-circle img-fluid" />
                                        </div>
                                        <div class="" style="width: 50%">
                                            <img :src="login_user.icon_url" class="rounded-circle img-fluid" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="padding-top: 10px">
                                <div class="row">
                                    <div class="col">
                                        <div class="item-line-on" v-for="card in card_list" :key="card.id">
                                            {{ card.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="padding-top: 10px" v-if="card_is_page && card_count != 0">
                                <div class="row">
                                    <div class="col">
                                        <div class="text-center" style="color: #9990ff">
                                            <a @click="fetchCardsMore()">もっとみる</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="padding-top: 30px">
                                <div class="row">
                                    <div class="col-3 px-0" v-for="user_card in user_card_list" :key="user_card.id">
                                        <a :href="'/card/detail/' + user_card.id
                                            " style="color: #000">
                                            <div style="margin: 8px">
                                                <img :src="user_card.thumbnail_image
                                                    " class="luna-rounded img-fluid" />
                                                <div>
                                                    <small>{{
                                                        user_card.name
                                                    }}</small>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div style="padding-top: 10px" v-if="user_card_is_page && user_card_count != 0">
                                <div class="row">
                                    <div class="col">
                                        <div class="text-center" style="color: #9990ff">
                                            <a @click="fetchUserCardsMore()">もっとみる</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div class="row" style="background: #e7e7ff">
                    <div class="col" style="padding-top: 10px; padding-bottom: 10px">
                        <b style="color: #000">{{ user.name }}さんの情報</b>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px">
                    <div class="col">
                        <b>自己紹介</b>
                        <!-- prettier-ignore -->
                        <p style="padding-top: 10px; white-space: pre-wrap">{{ user.profile?.trim() }}</p>
                    </div>
                </div>
                <br />
                <div class="row" style="background: #e7e7ff">
                    <div class="col" style="padding-top: 10px; padding-bottom: 10px"></div>
                </div>
                <div class="row" style="padding-top: 10px">
                    <div class="col">
                        <b>基本情報</b>
                        <div style="padding-top: 10px">
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    年齢
                                </div>
                                <div class="col" style="font-size: 12px">
                                    <div v-if="user.age_view">
                                        {{ user.age }}
                                    </div>
                                    <div v-else>秘密</div>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    居住地
                                </div>
                                <div class="col" style="font-size: 12px">
                                    {{ area_list[user.area] }}
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    プライベートのパートナー
                                </div>
                                <div class="col" style="font-size: 12px">
                                    <div v-if="user.is_private_partner == 1">
                                        既婚者
                                    </div>
                                    <div v-else-if="user.is_private_partner == 2">
                                        彼氏/彼女がいる
                                    </div>
                                    <div v-else-if="user.is_private_partner == 3">
                                        フリー
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    SMパートナー
                                </div>
                                <div class="col" style="font-size: 12px">
                                    <div v-if="user.is_smds_partner == 1">
                                        いない
                                    </div>
                                    <div v-else-if="user.is_smds_partner == 2">
                                        一人いる
                                    </div>
                                    <div v-else-if="user.is_smds_partner == 3">
                                        複数いる
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    タバコ
                                </div>
                                <div class="col" style="font-size: 12px">
                                    <div v-if="user.is_smoking == 1">
                                        吸わない
                                    </div>
                                    <div v-else-if="user.is_smoking == 2">
                                        吸う
                                    </div>
                                    <div v-else-if="user.is_smoking == 3">
                                        吸う(電子タバコ)
                                    </div>
                                    <div v-else-if="user.is_smoking == 4">
                                        非喫煙者の前では吸わない
                                    </div>
                                    <div v-else-if="user.is_smoking == 5">
                                        時々吸う
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    身長
                                </div>
                                <div class="col" style="font-size: 12px">
                                    <div v-if="user.body_height == 100">
                                        秘密
                                    </div>
                                    <div v-else-if="user.body_height == 129">
                                        130cm未満
                                    </div>
                                    <div v-else-if="user.body_height == 201">
                                        201cm以上
                                    </div>
                                    <div v-else-if="user.body_height == null">
                                        -
                                    </div>
                                    <div v-else>{{ user.body_height }}cm</div>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    体型
                                </div>
                                <div class="col" style="font-size: 12px">
                                    <div v-if="user.body_type == 1">スリム</div>
                                    <div v-else-if="user.body_type == 2">
                                        やや細め
                                    </div>
                                    <div v-else-if="user.body_type == 3">
                                        普通
                                    </div>
                                    <div v-else-if="user.body_type == 4">
                                        グラマー
                                    </div>
                                    <div v-else-if="user.body_type == 5">
                                        筋肉質
                                    </div>
                                    <div v-else-if="user.body_type == 6">
                                        ややぽっちゃり
                                    </div>
                                    <div v-else-if="user.body_type == 7">
                                        太め
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                    SM経験
                                </div>
                                <div class="col" style="font-size: 12px">
                                    <div v-if="user.sm_year == 1">未経験</div>
                                    <div v-else-if="user.sm_year == 2">
                                        1年未満
                                    </div>
                                    <div v-else-if="user.sm_year == 3">
                                        1年〜3年
                                    </div>
                                    <div v-else-if="user.sm_year == 4">
                                        4年〜6年
                                    </div>
                                    <div v-else-if="user.sm_year == 5">
                                        7年〜10年
                                    </div>
                                    <div v-else-if="user.sm_year == 6">
                                        11年以上
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-3" style="font-size: 12px; color: #6b4eff">
                                    性癖タイプ
                                </div>
                                <div class="col">
                                    <img :src="user.my_type_img_url" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div class="row" style="background: #e7e7ff">
                    <div class="col" style="padding-top: 10px; padding-bottom: 10px"></div>
                </div>
                <div class="row" style="padding-top: 10px">
                    <div class="col">
                        <b>好みについて</b>
                        <div style="padding-top: 10px">
                            <div class="row" style="padding-top: 10px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff"></div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/Group13205.png" class="img-fluid" />
                                </div>
                            </div>
                            <div class="row" style="padding-top: 10px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff">
                                    SEXについて
                                </div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/line_1.png" class="img-fluid" v-if="user.q_sex == 1" />
                                    <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_sex == 2" />
                                    <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_sex == 3" />
                                    <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_sex == 4" />
                                    <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_sex == 5" />
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff">
                                    苦痛について
                                </div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/line_1.png" class="img-fluid" v-if="user.q_pain == 1" />
                                    <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_pain == 2" />
                                    <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_pain == 3" />
                                    <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_pain == 4" />
                                    <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_pain == 5" />
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff">
                                    精神的な束縛/苦痛
                                </div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/line_1.png" class="img-fluid" v-if="user.q_dom == 1" />
                                    <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_dom == 2" />
                                    <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_dom == 3" />
                                    <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_dom == 4" />
                                    <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_dom == 5" />
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff">
                                    物理的な拘束について
                                </div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/line_1.png" class="img-fluid" v-if="user.q_restraint == 1" />
                                    <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_restraint == 2" />
                                    <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_restraint == 3" />
                                    <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_restraint == 4" />
                                    <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_restraint == 5" />
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff">
                                    羞恥について
                                </div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/line_1.png" class="img-fluid" v-if="user.q_shame == 1" />
                                    <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_shame == 2" />
                                    <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_shame == 3" />
                                    <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_shame == 4" />
                                    <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_shame == 5" />
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff">
                                    快楽について
                                </div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/line_1.png" class="img-fluid" v-if="user.q_pleasure == 1" />
                                    <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_pleasure == 2" />
                                    <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_pleasure == 3" />
                                    <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_pleasure == 4" />
                                    <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_pleasure == 5" />
                                </div>
                            </div>
                            <div class="row" style="padding-top: 20px">
                                <div class="col-5" style="font-size: 12px; color: #6b4eff">
                                    依存について
                                </div>
                                <div class="col" style="font-size: 12px; color: #6b4eff">
                                    <img src="/images/line_1.png" class="img-fluid" v-if="user.q_reliance == 1" />
                                    <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_reliance == 2" />
                                    <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_reliance == 3" />
                                    <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_reliance == 4" />
                                    <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_reliance == 5" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding-top: 30px">
                    <div class="col">
                        <div style="font-size: 12px; color: #6b4eff">
                            嗜好について
                        </div>
                        <!-- prettier-ignore -->
                        <p style="
                                color: #333333;
                                padding-top: 10px;
                                white-space: pre-wrap;
                            ">{{ user.text_my_like }}</p>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px">
                    <div class="col">
                        <div style="font-size: 12px; color: #6b4eff">
                            NGについて
                        </div>
                        <!-- prettier-ignore -->
                        <p style="
                                color: #333333;
                                padding-top: 10px;
                                white-space: pre-wrap;
                            ">{{ user.text_my_ng }}</p>
                        <br />
                        <div>
                            <div style="color: #6b4eff; font-size: 11px">
                                <i class="bi bi-exclamation-circle-fill"></i>相性の相違が起こりやすい項目です
                            </div>
                            <div style="color: #777; font-size: 11px">
                                ブロック対象の70%以上はプロフィールを読まずに適当にいいねをしています。<b style="color: #000">しっかりと読んだ上でいいね！を押しましょう。</b>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                <div class="row" style="
                        padding-top: 20px;
                        padding-bottom: 20px;
                        background-color: #e7e7ff;
                    ">
                    <div class="col">
                        <div class="item-box">
                            <b>相手に求める条件</b>
                            <!-- prettier-ignore -->
                            <p style="padding-top: 10px; white-space: pre-wrap">{{ user.conditions_text }}</p>
                            <div style="padding-top: 10px">
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-3" style="
                                            font-size: 12px;
                                            color: #6b4eff;
                                            white-space: nowrap;
                                        ">
                                        求める<br />性癖タイプ
                                    </div>
                                    <div class="col">
                                        <img :src="user.conditions_type_img_url" class="img-fluid" />
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                        性対象
                                    </div>
                                    <div class="col-6" style="font-size: 12px">
                                        {{ user.conditions_sex_text }}
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                        年齢
                                    </div>
                                    <div class="col-6" style="font-size: 12px">
                                        <div v-if="
                                            user.conditions_age_from !=
                                            null ||
                                            user.conditions_age_to != null
                                        ">
                                            {{
                                                age_list[
                                                user.conditions_age_from
                                                ]
                                            }}〜{{
                                                age_list[user.conditions_age_to]
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                        地域
                                    </div>
                                    <div class="col-6" style="font-size: 12px">
                                        {{ user.conditions_area_text }}
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                        体型
                                    </div>
                                    <div class="col-6" style="font-size: 12px">
                                        {{ user.conditions_body_text }}
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                        プライベートのパートナー
                                    </div>
                                    <div class="col-6" style="font-size: 12px">
                                        {{
                                            user.conditions_is_private_partner_text
                                        }}
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                        SM経験
                                    </div>
                                    <div class="col-6" style="font-size: 12px">
                                        {{ user.conditions_is_sm_text }}
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px">
                                    <div class="col-6" style="font-size: 12px; color: #6b4eff">
                                        関係性
                                    </div>
                                    <div class="col-6" style="font-size: 12px">
                                        <div class="col" v-if="user.conditions_real_net == 1">
                                            リアル必須
                                        </div>
                                        <div class="col" v-else-if="
                                            user.conditions_real_net == 2
                                        ">
                                            ネットのみ
                                        </div>
                                        <div class="col" v-else-if="
                                            user.conditions_real_net == 3
                                        ">
                                            どちらでもよい
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="background: #6b4eff" v-if="user.id != login_user.id">
                    <div class="col" style="padding-top: 20px; padding-bottom: 20px">
                        <br />
                        <div class="text-center">
                            <svg style="height: 60px; width: 60px; fill: #fff">
                                <use xlink:href="/images/check_crown.svg#check"></use>
                            </svg>
                        </div>
                        <div class="text-center" style="
                                color: #fff;
                                font-size: 20px;
                                padding-top: 10px;
                            ">
                            <b>最後まで読みました！</b>
                        </div>
                        <br />
                        <div class="text-center" style="color: #c6c4ff; font-size: 14px">
                            お気に入りに追加することで<br />
                            相手への通知なしで<br />
                            あとから確認することができます
                        </div>
                        <br />
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="d-grid gap-2" style="padding: 0 5px">
                                    <button type="button" class="btn btn-luna" style="
                                            font-size: 18px;
                                            padding: 12px 0;
                                            border: 1px solid #fff;
                                        " v-if="is_bookmark" @click="setBookmark(0)">
                                        <i class="bi bi-star-fill"></i>
                                        お気に入り解除
                                    </button>
                                    <button type="button" class="btn btn-luna-outline"
                                        style="font-size: 18px; padding: 12px 0" v-else @click="setBookmark(1)">
                                        <i class="bi bi-star-fill"></i>
                                        お気に入りに追加
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-if="is_bookmark_done">
                            <small v-if="is_bookmark">
                                お気に入りに追加しました。
                            </small>
                            <small v-else> お気に入りを解除しました。 </small>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
        </div>

        <div v-if="showFooterMenu" class="container-fluid luna-footer-menu-show">
            <!-- 未ログインユーザー -->
            <div v-if="isGuestUser" class="row">
                <div class="col">
                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-luna" style="padding: 12px 0;" @click="setAuth()">
                            ログインされてません
                        </button>
                    </div>
                </div>
            </div>

            <!-- 募集を停止している -->
            <div v-else-if="isSearchStopped" class="row">
                <div class="col">
                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0;">
                            募集停止中
                        </button>
                    </div>
                </div>
            </div>


            <!-- TODO: if分岐がとんでもないことになっているが定数の意味が不明なのでリファクタできず。この辺り要件を整理した方が良い -->
            <!-- その他 -->
            <div v-else>
                <div class="row" v-if="isOtherUserType">
                    <div class="col">
                        <template v-if="userType1FooterState === 'needs_certificate'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0;">
                                    <GoodIcon style="margin-right: 0.5rem" />
                                    年齢認証後に利用可能
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'like_resend_restricted'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0;">
                                    3 週間以内に再度いいねは送れません
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'premium_message_sent'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn sent-premium-message-button">
                                    プレミアムメッセージ送信済み
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'can_like'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-skip" style="padding: 12px 0;"
                                    @click="is_page_good = true">
                                    <GoodIcon style="margin-right: 0.5rem" />
                                    いいね
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'look_already_sent'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-look disabled" style="padding: 12px 0;">
                                    <GoodIcon style="margin-right: 0.5rem" />
                                    みてね済
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'look_limit_reached'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-look disabled" style="padding: 12px 0;">
                                    <GoodIcon style="margin-right: 0.5rem" />
                                    上限に達しました
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'can_look'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-look" style="padding: 12px 0;"
                                    @click="is_page_look = true">
                                    <GoodIcon style="margin-right: 0.5rem" />
                                    みてね
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'good_limit_reached'">
                            <div class="d-grid gap-2">
                                <RecommendPlanBanner v-if="showBanner"
                                    src="/images/recommend_banners/recommend_plan_update_banner_more_fav.png"
                                    alt="上限に達しました" />
                                <button type="button" class="btn btn-skip disabled mb-2" style="padding: 12px 0;">
                                    <GoodIcon style="margin-right: 0.5rem" />
                                    上限に達しました
                                </button>
                            </div>
                        </template>
                        <template v-else-if="userType1FooterState === 'paid_look'">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-look" style="padding: 12px 0;"
                                    onclick="alert('この機能は有料機能です。みてね！で気づいてもらえる確率が3倍になります。')">
                                    <GoodIcon style="margin-right: 0.5rem" />
                                    みてね
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="row" v-else-if="isReceivedLikeUserType">
                    <div class="col-5">
                        <div class="d-grid gap-2">
                            <button v-if="!isAgeVerified" type="button" class="btn btn-luna-d disabled"
                                style="padding: 12px 0;">
                                <i class="bi bi-arrow-return-left"></i>&nbsp;スキップ
                            </button>
                            <button v-else type="button" class="btn btn-skip-outline" style="padding: 12px 0;"
                                @click="setPenalty('skip', 1)">
                                <i class="bi bi-arrow-return-left"></i>&nbsp;スキップ
                            </button>
                        </div>
                    </div>
                    <div class="col">
                        <div class="d-grid gap-2">
                            <button v-if="!isAgeVerified" type="button" class="btn btn-luna-d disabled"
                                style="padding: 12px 0;">
                                <i class="bi bi-hand-thumbs-up"></i>&nbsp;ありがとう
                            </button>
                            <button v-else-if="hasMatchingComp" type="button" class="btn btn-skip disabled"
                                style="padding: 12px 0;">
                                <GoodIcon style="margin-right: 0.5rem" />
                                ありがとう済
                            </button>
                            <button v-else type="button" class="btn btn-skip" style="padding: 12px 0;"
                                @click="setMatching()">
                                <GoodIcon style="margin-right: 0.5rem" />
                                ありがとう
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" v-else-if="isMatchedUserType">
                    <div class="col">
                        <div class="d-grid gap-2">
                            <a type="button" class="btn btn-luna" style="padding: 12px 0"
                                :href="'/user/message/' + matching_id">
                                <i class="bi bi-chat" />
                                &nbsp;メッセージへ
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row" v-else-if="isSkippedUserType">
                    <div class="col">
                        <div class="d-grid gap-2">
                            <button v-if="!isAgeVerified" type="button" class="btn btn-luna-d disabled"
                                style="padding: 12px 0;">
                                <i class="bi bi-hand-thumbs-up"></i>&nbsp;ありがとう
                            </button>
                            <button v-else-if="hasMatchingComp" type="button" class="btn btn-skip disabled"
                                style="padding: 12px 0;">
                                <GoodIcon style="margin-right: 0.5rem" />
                                ありがとう済
                            </button>
                            <button v-else type="button" class="btn btn-skip" style="padding: 12px 0;"
                                @click="setMatching()">
                                <GoodIcon style="margin-right: 0.5rem" />
                                ありがとう
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="send-premium-message-resume-button-wrapper">
            <button v-if="showPremiumMessageDraftButton" type="button" class="send-premium-message-resume-button"
                @click="reopenPremiumMessageDraft">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5 19H6.2615L16.498 8.7635L15.2365 7.502L5 17.7385V19ZM3.5 20.5V17.1155L16.6905 3.93075C16.8417 3.79342 17.0086 3.68733 17.1913 3.6125C17.3741 3.5375 17.5658 3.5 17.7663 3.5C17.9668 3.5 18.1609 3.53558 18.3488 3.60675C18.5368 3.67792 18.7032 3.79108 18.848 3.94625L20.0693 5.18275C20.2244 5.32758 20.335 5.49425 20.401 5.68275C20.467 5.87125 20.5 6.05975 20.5 6.24825C20.5 6.44942 20.4657 6.64133 20.397 6.824C20.3283 7.00683 20.2191 7.17383 20.0693 7.325L6.8845 20.5H3.5ZM15.8562 8.14375L15.2365 7.502L16.498 8.7635L15.8562 8.14375Z"
                        fill="white" />
                </svg>
                下書きを開く
            </button>
        </div>

        <div class="send-good-modal-overlay" :class="!is_page_through && 'hide-modal-overlay'" id="good_page"
            v-if="is_page_good && !showPremiumMessageDraftButton">
            <div class="page-box">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-11">
                            <div class="card border-light" style="
                                    margin-top: 50px;
                                    background-color: #6b4eff;
                                    border: 0;
                                    padding: 10px;
                                " v-if="is_page_through">
                                <div class="row">
                                    <div class="col-2 px-0">
                                        <div style="
                                                padding: 0 10px;
                                                font-size: 25px;
                                                color: #fff;
                                            " @click="is_page_good = false">
                                            <i class="bi bi-x"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div style="
                                                color: #fff;
                                                font-size: 18px;
                                                padding: 10px 0;
                                            " class="text-center">
                                            <b>以前にいいねをしてから<br />
                                                スキップorスルーされてます
                                            </b>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <img src="/images/Group13494.png" style="width: 100%" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div style="
                                                color: #fbff26;
                                                font-size: 13px;
                                                padding: 20px 0;
                                            " class="text-center">
                                            プロフィールの登録内容を見直すことで<br />
                                            相手に興味を持ってもらいやすくなります
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="d-grid gap-2">
                                            <a type="button" class="btn btn-luna-outline" style="padding: 12px 0"
                                                href="/home">
                                                自分のプロフィールを見直す</a>
                                        </div>
                                        <br />
                                        <div class="text-center" style="color: #fff; font-size: 12px">
                                            <a @click="is_page_through = false">いいねを続ける ></a>
                                        </div>
                                        <br />
                                    </div>
                                </div>
                            </div>

                            <div class="card border-light send-good-half-modal" v-else>
                                <div class="card-body">
                                    <div class="close-modal" @click="is_page_good = false">
                                        <i class="bi bi-x"></i>
                                    </div>

                                    <div>
                                        <div class="send-good-heading">
                                            <div class="send-good-heading-text">
                                                <div v-if="login_user.is_limited">
                                                    いいねにメッセージを添えると<br />
                                                    通常の5倍<br />
                                                    出会える確率が上がります
                                                </div>
                                                <div v-else>
                                                    有料会員の98%が<br />
                                                    メッセージ付きいいねから<br />
                                                    出会っています
                                                </div>
                                            </div>
                                            <img src="/images/premium_message/message-letter.png"
                                                alt="message-letter" />
                                        </div>
                                        <div class="send-premium-message">
                                            <button
                                                class="send-premium-message-button"
                                                :class="isPremiumMessageButtonDisabled && 'disabled'"
                                                @click="handlePremiumMessageButtonClick"
                                            >
                                                <div class="send-premium-message-image-wrapper">
                                                    <img src="/images/premium_message/send-message.png" alt="プレミアムメッセージを送る" />
                                                    <span v-if="isEventPremiumMessageAvailable" class="event-badge-overlay">イベント限定</span>
                                                </div>
                                            </button>
                                            <!-- 両方のプレミアムメッセージ付きいいねが上限に達した場合のみ「上限に達しました」を表示 -->
                                            <span v-if="isPremiumMessageButtonDisabled && !login_user.is_limited" class="limited-premium-message">
                                                上限に達しました
                                            </span>
                                            <div class="rest-of-message">
                                                <!-- イベント限定プレミアムメッセージ付きいいねが送信可能な場合はその残り回数を表示 -->
                                                <div v-if="isEventPremiumMessageAvailable">
                                                    残り {{ eventPremiumMessageRemainingCount }}通
                                                </div>
                                                <!-- イベント限定プレミアムメッセージ付きいいねが使えない場合は通常プレミアムメッセージ付きいいねの残り回数を表示 -->
                                                <div v-else-if="isRegularPremiumMessageAvailable">
                                                    残り {{ login_user.premium_message_like_limit_count }}通
                                                </div>
                                                <div v-else-if="login_user.is_limited">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.90534 13.3333C4.65637 13.3333 4.44324 13.2444 4.26594 13.0666C4.08865 12.8887 4 12.675 4 12.4252V6.69786C4 6.44725 4.08865 6.23272 4.26594 6.05426C4.44324 5.8758 4.65637 5.78657 4.90534 5.78657H5.77199V4.57712C5.77199 3.86299 6.02121 3.25494 6.51966 2.75296C7.01812 2.25099 7.62236 2 8.33239 2C9.04241 2 9.64643 2.25099 10.1445 2.75296C10.6425 3.25494 10.8915 3.86299 10.8915 4.57712V5.78657H11.7581C12.008 5.78657 12.2219 5.8758 12.3998 6.05426C12.5777 6.23272 12.6667 6.44725 12.6667 6.69786V12.4252C12.6667 12.675 12.5777 12.8887 12.3998 13.0666C12.2219 13.2444 12.008 13.3333 11.7581 13.3333H4.90534ZM8.33397 10.5879C8.61597 10.5879 8.85663 10.49 9.05596 10.2942C9.25528 10.0984 9.35495 9.86311 9.35495 9.58821C9.35495 9.32163 9.25454 9.07949 9.05373 8.86178C8.85291 8.64408 8.6115 8.53522 8.32951 8.53522C8.04751 8.53522 7.80685 8.64408 7.60752 8.86178C7.40819 9.07949 7.30853 9.32385 7.30853 9.59487C7.30853 9.86589 7.40894 10.0991 7.60975 10.2946C7.81057 10.4901 8.05197 10.5879 8.33397 10.5879ZM6.67733 5.78657H9.98615V4.57785C9.98615 4.11233 9.82601 3.71819 9.50575 3.39543C9.18548 3.07267 8.79491 2.9113 8.33405 2.9113C7.87319 2.9113 7.48185 3.07267 7.16004 3.39543C6.83823 3.71819 6.67733 4.11233 6.67733 4.57785V5.78657Z" fill="#27272A"/>
                                                    </svg>
                                                    有料プラン限定
                                                </div>
                                            </div>
                                        </div>
                                        <div class="send-good-with-message">
                                            <button v-if="login_user.good_limit_count" type="button"
                                                class="send-good-button send-good-button--fill"
                                                :class="login_user.is_limited && !login_user.is_campaign_target && 'disabled'"
                                                @click="handleMessageLikeButtonClick">
                                                <svg v-if="!login_user.is_limited || login_user.is_campaign_target"
                                                    width="25" height="24" viewBox="0 0 25 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M8.51429 20C8.15714 20 7.85357 19.8779 7.60357 19.6338C7.35357 19.3897 7.22857 19.0933 7.22857 18.7446V9.78936C7.22857 9.63592 7.26071 9.48248 7.325 9.32904C7.38929 9.1756 7.47857 9.04309 7.59286 8.9315L12.0286 4.37018C12.2286 4.1749 12.4679 4.05633 12.7464 4.01449C13.025 3.97264 13.2857 4.02146 13.5286 4.16095C13.7714 4.30044 13.9536 4.49572 14.075 4.74681C14.1964 4.99789 14.2286 5.25594 14.1714 5.52097L13.3571 9.28719H20.2143C20.5429 9.28719 20.8393 9.41622 21.1036 9.67428C21.3679 9.93233 21.5 10.2218 21.5 10.5426V12.2583C21.5 12.4118 21.4821 12.5896 21.4464 12.7919C21.4107 12.9941 21.3571 13.172 21.2857 13.3254L18.8 18.9329C18.6714 19.2258 18.4607 19.4769 18.1679 19.6861C17.875 19.8954 17.5643 20 17.2357 20H8.51429ZM4.72143 20C4.39286 20 4.10714 19.8814 3.86429 19.6443C3.62143 19.4072 3.5 19.1282 3.5 18.8074V10.4798C3.5 10.159 3.62143 9.88003 3.86429 9.64289C4.10714 9.40576 4.39286 9.28719 4.72143 9.28719C5.05 9.28719 5.33571 9.40576 5.57857 9.64289C5.82143 9.88003 5.94286 10.159 5.94286 10.4798V18.8074C5.94286 19.1282 5.82143 19.4072 5.57857 19.6443C5.33571 19.8814 5.05 20 4.72143 20Z"
                                                        fill="white" />
                                                </svg>
                                                <svg v-else width="25" height="24" viewBox="0 0 25 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M8.51429 20C8.15714 20 7.85357 19.8779 7.60357 19.6338C7.35357 19.3897 7.22857 19.0933 7.22857 18.7446V9.78936C7.22857 9.63592 7.26071 9.48248 7.325 9.32904C7.38929 9.1756 7.47857 9.04309 7.59286 8.9315L12.0286 4.37018C12.2286 4.1749 12.4679 4.05633 12.7464 4.01449C13.025 3.97264 13.2857 4.02146 13.5286 4.16095C13.7714 4.30044 13.9536 4.49572 14.075 4.74681C14.1964 4.99789 14.2286 5.25594 14.1714 5.52097L13.3571 9.28719H20.2143C20.5429 9.28719 20.8393 9.41622 21.1036 9.67428C21.3679 9.93233 21.5 10.2218 21.5 10.5426V12.2583C21.5 12.4118 21.4821 12.5896 21.4464 12.7919C21.4107 12.9941 21.3571 13.172 21.2857 13.3254L18.8 18.9329C18.6714 19.2258 18.4607 19.4769 18.1679 19.6861C17.875 19.8954 17.5643 20 17.2357 20H8.51429ZM4.72143 20C4.39286 20 4.10714 19.8814 3.86429 19.6443C3.62143 19.4072 3.5 19.1282 3.5 18.8074V10.4798C3.5 10.159 3.62143 9.88003 3.86429 9.64289C4.10714 9.40576 4.39286 9.28719 4.72143 9.28719C5.05 9.28719 5.33571 9.40576 5.57857 9.64289C5.82143 9.88003 5.94286 10.159 5.94286 10.4798V18.8074C5.94286 19.1282 5.82143 19.4072 5.57857 19.6443C5.33571 19.8814 5.05 20 4.72143 20Z"
                                                        fill="#BAB9C0" />
                                                </svg>
                                                メッセージ付きいいね
                                            </button>
                                            <button v-else type="button" class="send-good-button disabled">
                                                上限に達しました
                                            </button>
                                            <div class="send-good-with-message-note">
                                                <div class="send-good-with-message-note-text">
                                                    メッセージ付きの返信率は通常いいねの5倍です
                                                </div>
                                                <div class="rest-of-message">
                                                    <div v-if="!login_user.is_limited || login_user.is_campaign_target"
                                                        class="rest-of-message-good">
                                                        残り {{ login_user.good_limit_count }}通
                                                    </div>
                                                    <div v-else>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M4.90534 13.3333C4.65637 13.3333 4.44324 13.2444 4.26594 13.0666C4.08865 12.8887 4 12.675 4 12.4252V6.69786C4 6.44725 4.08865 6.23272 4.26594 6.05426C4.44324 5.8758 4.65637 5.78657 4.90534 5.78657H5.77199V4.57712C5.77199 3.86299 6.02121 3.25494 6.51966 2.75296C7.01812 2.25099 7.62236 2 8.33239 2C9.04241 2 9.64643 2.25099 10.1445 2.75296C10.6425 3.25494 10.8915 3.86299 10.8915 4.57712V5.78657H11.7581C12.008 5.78657 12.2219 5.8758 12.3998 6.05426C12.5777 6.23272 12.6667 6.44725 12.6667 6.69786V12.4252C12.6667 12.675 12.5777 12.8887 12.3998 13.0666C12.2219 13.2444 12.008 13.3333 11.7581 13.3333H4.90534ZM8.33397 10.5879C8.61597 10.5879 8.85663 10.49 9.05596 10.2942C9.25528 10.0984 9.35495 9.86311 9.35495 9.58821C9.35495 9.32163 9.25454 9.07949 9.05373 8.86178C8.85291 8.64408 8.6115 8.53522 8.32951 8.53522C8.04751 8.53522 7.80685 8.64408 7.60752 8.86178C7.40819 9.07949 7.30853 9.32385 7.30853 9.59487C7.30853 9.86589 7.40894 10.0991 7.60975 10.2946C7.81057 10.4901 8.05197 10.5879 8.33397 10.5879ZM6.67733 5.78657H9.98615V4.57785C9.98615 4.11233 9.82601 3.71819 9.50575 3.39543C9.18548 3.07267 8.79491 2.9113 8.33405 2.9113C7.87319 2.9113 7.48185 3.07267 7.16004 3.39543C6.83823 3.71819 6.67733 4.11233 6.67733 4.57785V5.78657Z"
                                                                fill="#27272A" />
                                                        </svg>
                                                        有料プラン限定
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="send-good">
                                            <button v-if="login_user.good_limit_count" type="button"
                                                class="send-good-button send-good-button--outline" @click="
                                                    (text_good_message = ''),
                                                    setGood(1)">
                                                <div class="spinner-border" style="
                                                        width: 1rem;
                                                        height: 1rem;
                                                    " v-if="is_load">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>

                                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M8.51429 20C8.15714 20 7.85357 19.8779 7.60357 19.6338C7.35357 19.3897 7.22857 19.0933 7.22857 18.7446V9.78936C7.22857 9.63592 7.26071 9.48248 7.325 9.32904C7.38929 9.1756 7.47857 9.04309 7.59286 8.9315L12.0286 4.37018C12.2286 4.1749 12.4679 4.05633 12.7464 4.01449C13.025 3.97264 13.2857 4.02146 13.5286 4.16095C13.7714 4.30044 13.9536 4.49572 14.075 4.74681C14.1964 4.99789 14.2286 5.25594 14.1714 5.52097L13.3571 9.28719H20.2143C20.5429 9.28719 20.8393 9.41622 21.1036 9.67428C21.3679 9.93233 21.5 10.2218 21.5 10.5426V12.2583C21.5 12.4118 21.4821 12.5896 21.4464 12.7919C21.4107 12.9941 21.3571 13.172 21.2857 13.3254L18.8 18.9329C18.6714 19.2258 18.4607 19.4769 18.1679 19.6861C17.875 19.8954 17.5643 20 17.2357 20H8.51429ZM4.72143 20C4.39286 20 4.10714 19.8814 3.86429 19.6443C3.62143 19.4072 3.5 19.1282 3.5 18.8074V10.4798C3.5 10.159 3.62143 9.88003 3.86429 9.64289C4.10714 9.40576 4.39286 9.28719 4.72143 9.28719C5.05 9.28719 5.33571 9.40576 5.57857 9.64289C5.82143 9.88003 5.94286 10.159 5.94286 10.4798V18.8074C5.94286 19.1282 5.82143 19.4072 5.57857 19.6443C5.33571 19.8814 5.05 20 4.72143 20Z"
                                                        fill="#5538EE" />
                                                </svg>
                                                いいねを送る
                                            </button>
                                            <button v-else type="button" class="send-good-button disabled">
                                                上限に達しました
                                            </button>
                                            <div class="rest-of-message rest-of-message-good">
                                                残り {{ login_user.good_limit_count }}通
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PremiumMessageSend v-if="viewPremiumMessageSend" @close="closePremiumMessageSend"
                                @show-profile="handlePremiumMessageShowProfile"
                                @draft-change="updatePremiumMessageDraft"
                                @completed="handlePremiumMessageCompleted"
                                :user="user"
                                :draft-message="premiumMessageDraft"
                                :login-user="login_user"
                                :event-group-id="eventGroupId"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="
                z-index: 999999;
                background-color: rgba(0, 0, 0, 0.29);
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            " id="good_page" v-if="is_page_look">
            <div class="page-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="card border-light" style="
                                    margin-top: 50px;
                                    background-color: #6b4eff;
                                    border: 0;
                                    padding: 10px;
                                " v-if="is_page_through">
                                <div class="row">
                                    <div class="col-2 px-0">
                                        <div style="
                                                padding: 0 10px;
                                                font-size: 25px;
                                                color: #fff;
                                            " @click="is_page_look = false">
                                            <i class="bi bi-x"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div style="
                                                color: #fff;
                                                font-size: 18px;
                                                padding: 10px 0;
                                            " class="text-center">
                                            <b>以前にいいねをしてから<br />
                                                スキップorスルーされてます
                                            </b>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <img src="/images/Group13494.png" style="width: 100%" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div style="
                                                color: #fbff26;
                                                font-size: 13px;
                                                padding: 20px 0;
                                            " class="text-center">
                                            プロフィールの登録内容を見直すことで<br />
                                            相手に興味を持ってもらいやすくなります
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="d-grid gap-2">
                                            <a type="button" class="btn btn-luna-outline" style="padding: 12px 0"
                                                href="/home">
                                                自分のプロフィールを見直す</a>
                                        </div>
                                        <br />
                                        <div class="text-center" style="color: #fff; font-size: 12px">
                                            <a @click="is_page_through = false">いいねを続ける ></a>
                                        </div>
                                        <br />
                                    </div>
                                </div>
                            </div>

                            <div class="card border-light" style="margin-top: 80px" v-else>
                                <div style="
                                        position: fixed;
                                        z-index: 9999;
                                        margin-left: -75px;
                                        left: 50%;
                                        margin-top: -60px;
                                    ">
                                    <img :src="user.icon_url" class="rounded-circle" style="
                                            width: 130px;
                                            border: #fff 5px solid;
                                        " />
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-2 px-0">
                                            <div style="
                                                    padding: 0 10px;
                                                    font-size: 25px;
                                                " @click="is_page_look = false">
                                                <i class="bi bi-x"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <h5 class="card-title text-center">
                                        みてね！をしますか？
                                    </h5>
                                    <br />
                                    <div class="row">
                                        <div class="col-1"></div>
                                        <div class="col">
                                            <div class="card" style="
                                                    background-color: #f2f4f5;
                                                ">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col text-center">
                                                            みてね! を送ると<br />気づいてもらえる可能性が3倍アップ！
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-1"></div>
                                    </div>
                                    <br />
                                    <br />
                                    <div class="row">
                                        <div class="col">
                                            <div class="d-grid gap-2">
                                                <button type="button" class="btn btn-look" style="padding: 12px 0;"
                                                    @click="setLook()">
                                                    <div class="spinner-border" style="
                                                            width: 1rem;
                                                            height: 1rem;
                                                        " v-if="is_load">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>

                                                    <svg style="
                                                            height: 15px;
                                                            width: 15px;
                                                            fill: #fff;
                                                        ">
                                                        <use xlink:href="/images/good.svg#good"></use>
                                                    </svg>
                                                    &nbsp;みてね
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="
                z-index: 999999;
                background-color: rgba(0, 0, 0, 0.29);
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            " id="good_message_page" v-if="is_page_good_message">
            <div class="page-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="card border-light" style="margin-top: 80px">
                                <div style="
                                        position: fixed;
                                        z-index: 9999;
                                        margin-left: -75px;
                                        left: 50%;
                                        margin-top: -60px;
                                    ">
                                    <img :src="user.icon_url" class="rounded-circle" style="
                                            width: 130px;
                                            border: #fff 5px solid;
                                        " />
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-2 px-0">
                                            <div style="
                                                    padding: 0 10px;
                                                    font-size: 25px;
                                                " @click="
                                                    is_page_good_message = false
                                                    ">
                                                <i class="bi bi-x"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <div class="text-center">
                                        <b>あなたの「好き」を伝えましょう！</b>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col">
                                            <textarea class="luna-form-control" id="good_message" name="good_message"
                                                v-model="text_good_message" rows="5" placeholder="メッセージを入力"></textarea>
                                            <div class="text-end" style="
                                                    color: #999;
                                                    font-size: 12px;
                                                ">
                                                {{
                                                    message_count
                                                    | priceLocaleString
                                                }}/200文字
                                            </div>
                                            <div class="text-start" style="
                                                    color: #999;
                                                    font-size: 10px;
                                                ">
                                                ■
                                                SNSのID等連絡先の入力は送信できません。
                                            </div>
                                            <p class="error-text" id="error-good_message" v-if="!is_set">
                                                文字数がオーバーしています（最大200文字）
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col">
                                            <div class="d-grid gap-2">
                                                <button type="button" class="btn btn-skip" style="padding: 12px 0;"
                                                    @click="setGood(2)" id="on-btn" v-if="is_set">
                                                    <div class="spinner-border" style="
                                                            width: 1rem;
                                                            height: 1rem;
                                                        " v-if="is_load">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                    <svg style="
                                                            height: 18px;
                                                            width: 18px;
                                                            fill: #fff;
                                                        ">
                                                        <use xlink:href="/images/mail.svg#mail"></use>
                                                    </svg>
                                                    &nbsp;&nbsp;送信
                                                </button>
                                                <button type="button" class="btn btn-luna-d disabled" style="
                                                        padding: 12px 0;
                                                        border-radius: 50px;
                                                    " id="non-btn" v-else>
                                                    <svg style="
                                                            height: 18px;
                                                            width: 18px;
                                                            fill: #fff;
                                                        ">
                                                        <use xlink:href="/images/mail.svg#mail"></use>
                                                    </svg>
                                                    &nbsp;&nbsp;送信
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="
                z-index: 999999;
                background-color: rgba(0, 0, 0, 0.29);
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
            " id="penalty_page" v-if="is_page_penalty">
            <div class="page-box report-modal-container">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="card border-light report-modal-card">
                                <div class="card-body">
                                    <div class="card-subject">
                                        <div class="card-subject-close" @click="
                                            (is_page_penalty = false),
                                            (item_penalty = reset_item_penalty)
                                            ">
                                            <i class="bi bi-x"></i>
                                        </div>
                                        <p class="card-subject-text">通報する</p>
                                    </div>
                                    <input type="hidden" name="penalty" value="0" id="penalty" />

                                    <div class="card-content">
                                        <div class="reason-item" :class="{ active: item_penalty === 1 }"
                                            @click="onChangeReason(1)">
                                            金銭のやりとりが目的
                                        </div>
                                        <div class="reason-item" :class="{ active: item_penalty === 2 }"
                                            @click="onChangeReason(2)">
                                            18歳未満
                                        </div>
                                        <div class="reason-item" :class="{ active: item_penalty === 3 }"
                                            @click="onChangeReason(3)">
                                            危険な目に遭わされた
                                        </div>
                                        <div class="reason-item" :class="{ active: item_penalty === 4 }"
                                            @click="onChangeReason(4)">
                                            不審な内容または業者アカウントである
                                        </div>
                                        <div class="reason-item" :class="{ active: item_penalty === 5 }"
                                            @click="onChangeReason(5)">
                                            記載の内容に大幅な虚偽がある
                                        </div>
                                        <div class="reason-item" :class="{ active: item_penalty === 6 }"
                                            @click="onChangeReason(6)">
                                            会話のやり取りが攻撃的である
                                        </div>
                                        <div class="reason-item" :class="{ active: item_penalty === 7 }"
                                            @click="onChangeReason(7)">
                                            センシティブな画像を表示している
                                        </div>
                                        <div class="row g-3 align-items-center">
                                            <div class="col">
                                                <p class="error-text" id="error-detail_text" v-if="is_detail_text">
                                                    <i class="bi bi-x-circle-fill"></i>文字数がオーバーしています（最大400文字）
                                                </p>
                                                <div class="textarea-container"
                                                    :class="{ active: detail_text || isDetailTextFocused }">
                                                    <label for="detail_text" class="floating-label"
                                                        :class="{ active: detail_text || isDetailTextFocused }">
                                                        その他
                                                    </label>
                                                    <div class="textarea-wrapper">
                                                        <textarea class="luna-form-control reason-detail"
                                                            id="detail_text" name="detail_text" rows="3"
                                                            v-model="detail_text" @focus="isDetailTextFocused = true"
                                                            @blur="isDetailTextFocused = false"
                                                            :class="{ focused: isDetailTextFocused }"></textarea>
                                                    </div>
                                                    <div class="char-counter">{{ detail_text.length }}/400</div>
                                                </div>

                                                <div class="row">
                                                    <input style="display: none" ref="input" type="file"
                                                        accept="image/jpeg, image/jpg, image/png"
                                                        @change="selectedFile()" />
                                                    <div class="select-file" v-if="is_load_p">
                                                        <button type="button"
                                                            class="btn btn-luna-outline btn-select-file"
                                                            @click="btnclick">
                                                            画像を添付
                                                        </button>
                                                        <p class="select-file-description">形式は jpg/png が対象です</p>
                                                    </div>
                                                    <div class="d-grid gap-2" v-else>
                                                        <div class="selected-file-info" v-if="selectedFileName">
                                                            <i class="bi bi-paperclip"></i> {{ selectedFileName }}
                                                        </div>
                                                        <div class="delete-file" @click="cancel">
                                                            <img src="/images/icon/delete.png" alt="delete"
                                                                width="24" />
                                                            画像を削除する
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="btn-report-wrapper">
                                        <button type="button" class="btn btn-report"
                                            :class="(is_page_good_message_btn || (detail_text.length >= 1 && detail_text.length <= 400)) && (detail_text.length <= 400) ? 'btn-luna' : 'btn-luna-d disabled'"
                                            :disabled="!((is_page_good_message_btn || (detail_text.length >= 1 && detail_text.length <= 400)) && (detail_text.length <= 400))"
                                            @click="setPenalty('report', 1)">
                                            通報する
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loadImage from "blueimp-load-image";
import PremiumMessageSend from "../Matching/components/PremiumMessageSend.vue";

const USER_TYPE = Object.freeze({
    OWN_PROFILE: 0,
    OTHER_USER: 1,
    RECEIVED_LIKE: 2,
    MATCHED: 3,
    SKIPPED: 4,
    GUEST: 99,
});

export default {
    components: {
        PremiumMessageSend,
    },
    data() {
        return {
            USER_TYPE,
            age_list: [],
            area_list: [],
            block_users: 0,
            icon_list: [],
            is_block: false,
            is_bookmark: false,
            is_load: false,
            is_menu: false,
            is_page_good_message_btn: false,
            is_page_good_message: false,
            is_page_good: false,
            is_page_look: false,
            is_page_penalty: false,
            is_penalty: false,
            is_set: true,
            item_penalty: 0,
            image_tag: "",
            login_user: [],
            main_icon: "",
            matchings_comp: 0,
            matchings_good: 0,
            matchings_look: 0,
            matchings_premium_message_like: 0,
            matching_id: 0,
            matching_comment_to_me: "",
            max_tap: 0,
            penalty_users: 0,
            prev_page: "",
            prev_type: 0,
            reset_item_penalty: 0,
            sex_list: [],
            tab: 1,
            tap: 0,
            text_good_message: "",
            user_type: USER_TYPE.OWN_PROFILE,
            user: [],
            is_user_suspended: false,
            is_profile_restricted: false,
            suspended_user_info: null,
            detail_text: "",
            is_detail_text: false,
            isDetailTextFocused: false,
            is_load_p: true,
            file: null,
            selectedFileName: "",
            a: false,
            b: false,
            c: false,
            d: false,
            e: false,
            f: false,
            g: false,
            h: false,
            i: false,
            j: false,
            k: false,
            l: false,
            m: false,
            n: false,
            o: false,
            p: false,
            q: false,
            r: false,
            s: false,
            t: false,
            u: false,
            v: false,
            con_a: false,
            con_b: false,
            con_c: false,
            con_d: false,
            con_e: false,
            con_f: false,
            con_g: false,
            con_h: false,
            con_i: false,
            con_j: false,
            con_k: false,
            con_l: false,
            con_m: false,
            con_n: false,
            con_o: false,
            con_p: false,
            con_q: false,
            con_r: false,
            con_s: false,
            con_t: false,
            con_u: false,
            con_v: false,
            message_count: 0,
            is_relationship_list_1: false,
            is_relationship_list_2: false,
            is_relationship_list_3: false,
            is_relationship_list_4: false,
            is_relationship_list_5: false,
            is_relationship_list_6: false,
            is_relationship_list_7: false,
            is_relationship_list_8: false,
            is_relationship_list_9: false,

            card_list: [],
            card_count: 0,
            card_page: 1,
            card_is_load: true,
            card_is_page: true,

            user_card_list: [],
            user_card_count: 0,
            user_card_page: 1,
            user_card_is_load: true,
            user_card_is_page: true,

            is_page_init: true,
            is_bookmark_done: false,

            is_page_through: false,
            is_like_resend_restricted: false,

            // バナーを表示するかどうか
            showBanner: true,

            // プレミアムメッセージ
            premiumMessage: "",
            premiumMessageDraft: "",
            showPremiumMessageDraftButton: false,
            viewPremiumMessageSend: false,
            // イベント限定プレミアムメッセージ
            eventPremiumMessageLike: {
                event_group_id: null,
                remaining_count: 0,
            },
        };
    },
    computed: {
        /**
         * イベントコンテキストが存在するかどうか（送信可能かは問わない）
         * 表示用: 「イベント限定」バッジの表示などに使用
         */
        hasEventContext() {
            return this.eventPremiumMessageLike.event_group_id !== null;
        },
        /**
         * イベントコンテキストが存在し、かつ送信可能かどうか
         */
        isEventPremiumMessageAvailable() {
            return this.hasEventContext && this.eventPremiumMessageLike.remaining_count > 0;
        },
        /**
         * 通常プレミアムメッセージ付きいいねが送信可能かどうか
         */
        isRegularPremiumMessageAvailable() {
            return !this.login_user?.is_limited && this.login_user?.premium_message_like_limit_count > 0;
        },
        /**
         * イベント限定プレミアムメッセージ付きいいねが送信可能な場合のみeventGroupIdを返す
         * 送信不可の場合はnullを返し、通常プレミアムメッセージ付きいいねとして扱われる
         */
        eventGroupId() {
            return this.isEventPremiumMessageAvailable ? this.eventPremiumMessageLike.event_group_id : null;
        },
        eventPremiumMessageRemainingCount() {
            return this.eventPremiumMessageLike.remaining_count;
        },
        /**
         * プレミアムメッセージ付きいいねボタンの無効化判定
         * - イベント限定プレミアムメッセージ付きいいね送信可能、または通常プレミアムメッセージ付きいいね送信可能ならボタン有効
         * - 両方送信不可の場合のみ無効
         */
        isPremiumMessageButtonDisabled() {
            // イベント限定プレミアムメッセージ付きいいねまたは通常プレミアムメッセージ付きいいねが送信可能ならボタン有効
            if (this.isEventPremiumMessageAvailable || this.isRegularPremiumMessageAvailable) {
                return false;
            }
            // 両方送信不可の場合は無効
            return true;
        },
        isLikeResendRestricted() {
            return this.is_like_resend_restricted;
        },
        showFooterMenu() {
            return !this.is_page_init
                && !this.is_user_suspended
                && !this.is_profile_restricted
                && !this.showPremiumMessageDraftButton;
        },
        isGuestUser() {
            return this.user_type == this.USER_TYPE.GUEST;
        },
        isSearchStopped() {
            return this.user_type == this.USER_TYPE.OTHER_USER && this.user?.is_search_view == 0;
        },
        isOtherUserType() {
            return this.user_type == this.USER_TYPE.OTHER_USER;
        },
        isReceivedLikeUserType() {
            return this.user_type == this.USER_TYPE.RECEIVED_LIKE;
        },
        isMatchedUserType() {
            return this.user_type == this.USER_TYPE.MATCHED;
        },
        isSkippedUserType() {
            return this.user_type == this.USER_TYPE.SKIPPED;
        },
        isAgeVerified() {
            return this.login_user?.is_certificate == 11;
        },
        hasMatchingComp() {
            return this.matchings_comp != 0;
        },
        userType1FooterState() {
            if (!this.isAgeVerified) {
                return "needs_certificate";
            }

            if (this.isLikeResendRestricted) {
                return "like_resend_restricted";
            }

            if (this.matchings_premium_message_like === 1) {
                return "premium_message_sent";
            }

            const hasGood = this.matchings_good != 0;
            const hasLook = this.matchings_look != 0;

            if (this.login_user?.can_use_all_features) {
                if (!hasGood && !hasLook) {
                    return "can_like";
                }
                if (hasLook) {
                    return "look_already_sent";
                }
                if (this.login_user?.look_limit_count == 0) {
                    return "look_limit_reached";
                }
                return "can_look";
            }

            if (!hasGood) {
                if (this.login_user?.good_limit_count == 0) {
                    return "good_limit_reached";
                }
                if (hasLook) {
                    return "paid_look";
                }
                return "can_like";
            }

            return "paid_look";
        },
    },
    async mounted() {
        window.addEventListener('scroll', this.handleScroll)
        await this.fetchEventPremiumMessageLikeEligibility()
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop
            this.showBanner = scrollPosition <= 200
        },
        async fetchEventPremiumMessageLikeEligibility() {
            try {
                const response = await axios.get(
                    `/api/v2/users/${this.$route.params.uid}/event-premium-message-like-eligibility`
                )
                this.eventPremiumMessageLike = response.data
            } catch (error) {
                // エラー時はデフォルト値のまま（送信不可）
                console.error('Failed to fetch event premium message like eligibility:', error)
            }
        },
        // プレミアムメッセージ
        openPremiumMessageSend() {
            this.viewPremiumMessageSend = true
            this.showPremiumMessageDraftButton = false
        },
        handlePremiumMessageButtonClick() {
            // イベント限定プレミアムメッセージ付きいいねが送信可能な場合は優先
            if (this.isEventPremiumMessageAvailable) {
                this.openPremiumMessageSend()
                return
            }

            // イベント限定プレミアムメッセージ付きいいねが使えない場合、通常プレミアムメッセージ付きいいねにフォールバック
            if (this.isRegularPremiumMessageAvailable) {
                this.openPremiumMessageSend()
                return
            }

            // 無料ユーザーはプラン購入ページへ
            if (this.login_user?.is_limited) {
                window.open('/plan', '_self')
                return
            }

            // 両方上限到達の場合は何もしない（ボタンは無効化されているはず）
        },
        handleMessageLikeButtonClick() {
            if (this.login_user?.is_limited && !this.login_user?.is_campaign_target) {
                window.open('/plan', '_self')
                return
            }
            this.is_page_good = false
            this.is_page_good_message = true
        },
        reopenPremiumMessageDraft() {
            this.viewPremiumMessageSend = true
            this.showPremiumMessageDraftButton = false
        },
        handlePremiumMessageShowProfile(message) {
            this.premiumMessageDraft = message
            this.viewPremiumMessageSend = false
            this.showPremiumMessageDraftButton = true
        },
        updatePremiumMessageDraft(message) {
            this.premiumMessageDraft = message
        },
        handlePremiumMessageCompleted() {
            this.matchings_premium_message_like = 1
        },
        closePremiumMessageSend() {
            this.is_page_good = false
            this.viewPremiumMessageSend = false
            this.premiumMessageDraft = ''
            this.showPremiumMessageDraftButton = false
        },
        // 前ページ情報の初期化処理
        initializePrevPageInfo() {
            let _tab = this.$route.query.tab != undefined ? this.$route.query.tab : 1;
            this.tab = _tab;

            if (localStorage.getItem("prev_type") !== null) {
                this.prev_type = localStorage.getItem("prev_type");
                this.prev_page = localStorage.getItem("prev_page");

                localStorage.removeItem("prev_type");
                localStorage.removeItem("prev_page");
            }

            if (
                this.$route.params["type"] != undefined &&
                this.$route.params["type"] == 3
            ) {
                this.prev_type = this.USER_TYPE.GUEST;
            }
        },
        async updateInformationMarkAsReadByUser() {
            await axios
                .put(
                    `/api/information/read/mark_as/${this.$route.params["uid"]}`
                )
                .catch((error) => {
                    console.error(error);
                    this.$toasted.error("通知の既読処理更新に失敗しました", {
                        icon: "error",
                    });
                });
        },
        async fetchUsers() {
            await axios
                .get("/api/user/service/show/" + this.$route.params["uid"])
                .then((response) => {
                    this.user = response.data.user;
                    this.matching_id = response.data.mid;
                    this.matching_comment_to_me =
                        response.data.matching_comment_to_me;
                    this.image_tag = response.data.image_tag;

                    if (response.data.through_matching_cnt > 0) {
                        this.is_page_through = true;
                    }

                    this.a = this.user.my_types.indexOf("A") !== -1;
                    this.b = this.user.my_types.indexOf("B") !== -1;
                    this.c = this.user.my_types.indexOf("C") !== -1;
                    this.d = this.user.my_types.indexOf("D") !== -1;
                    this.e = this.user.my_types.indexOf("E") !== -1;
                    this.f = this.user.my_types.indexOf("F") !== -1;
                    this.g = this.user.my_types.indexOf("G") !== -1;
                    this.h = this.user.my_types.indexOf("H") !== -1;
                    this.i = this.user.my_types.indexOf("I") !== -1;
                    this.j = this.user.my_types.indexOf("J") !== -1;
                    this.k = this.user.my_types.indexOf("K") !== -1;
                    this.l = this.user.my_types.indexOf("L") !== -1;
                    this.m = this.user.my_types.indexOf("M") !== -1;
                    this.n = this.user.my_types.indexOf("N") !== -1;
                    this.o = this.user.my_types.indexOf("O") !== -1;
                    this.p = this.user.my_types.indexOf("P") !== -1;
                    this.q = this.user.my_types.indexOf("Q") !== -1;
                    this.r = this.user.my_types.indexOf("R") !== -1;
                    this.s = this.user.my_types.indexOf("S") !== -1;
                    this.t = this.user.my_types.indexOf("T") !== -1;
                    this.u = this.user.my_types.indexOf("U") !== -1;
                    this.v = this.user.my_types.indexOf("V") !== -1;

                    this.con_a = this.user.conditions_types.indexOf("A") !== -1;
                    this.con_b = this.user.conditions_types.indexOf("B") !== -1;
                    this.con_c = this.user.conditions_types.indexOf("C") !== -1;
                    this.con_d = this.user.conditions_types.indexOf("D") !== -1;
                    this.con_e = this.user.conditions_types.indexOf("E") !== -1;
                    this.con_f = this.user.conditions_types.indexOf("F") !== -1;
                    this.con_g = this.user.conditions_types.indexOf("G") !== -1;
                    this.con_h = this.user.conditions_types.indexOf("H") !== -1;
                    this.con_i = this.user.conditions_types.indexOf("I") !== -1;
                    this.con_j = this.user.conditions_types.indexOf("J") !== -1;
                    this.con_k = this.user.conditions_types.indexOf("K") !== -1;
                    this.con_l = this.user.conditions_types.indexOf("L") !== -1;
                    this.con_m = this.user.conditions_types.indexOf("M") !== -1;
                    this.con_n = this.user.conditions_types.indexOf("N") !== -1;
                    this.con_o = this.user.conditions_types.indexOf("O") !== -1;
                    this.con_p = this.user.conditions_types.indexOf("P") !== -1;
                    this.con_q = this.user.conditions_types.indexOf("Q") !== -1;
                    this.con_r = this.user.conditions_types.indexOf("R") !== -1;
                    this.con_s = this.user.conditions_types.indexOf("S") !== -1;
                    this.con_t = this.user.conditions_types.indexOf("T") !== -1;
                    this.con_u = this.user.conditions_types.indexOf("U") !== -1;
                    this.con_v = this.user.conditions_types.indexOf("V") !== -1;

                    if (this.user.relationship !== null) {
                        const relationships = this.user.relationship.toString().split(',');
                        this.is_relationship_list_1 = relationships.includes("1");
                        this.is_relationship_list_2 = relationships.includes("2");
                        this.is_relationship_list_3 = relationships.includes("3");
                        this.is_relationship_list_4 = relationships.includes("4");
                        this.is_relationship_list_5 = relationships.includes("5");
                        this.is_relationship_list_6 = relationships.includes("6");
                        this.is_relationship_list_7 = relationships.includes("7");
                        this.is_relationship_list_8 = relationships.includes("8");
                        this.is_relationship_list_9 = relationships.includes("9");
                    }

                    this.is_page_init = false;
                })
                .catch((error) => {
                    console.error(error);

                    // 凍結されたユーザーの場合（403エラー）
                    if (error.response && error.response.status === 403 && error.response.data.is_suspended) {
                        this.is_user_suspended = true;
                        this.suspended_user_info = error.response.data.user;
                        this.is_page_init = false; // ローディング状態を終了

                        // 凍結ユーザー表示時も前ページ情報を初期化
                        this.initializePrevPageInfo();
                    }
                    // ブロック・通報関係にあるユーザーの場合（403エラー）
                    else if (error.response && error.response.status === 403 && error.response.data.error_code === 403) {
                        this.is_profile_restricted = true;
                        this.is_page_init = false;

                        this.initializePrevPageInfo();
                    }
                    // 退会されたユーザーの場合（410エラー）
                    else if (error.response && error.response.status === 410 && error.response.data.is_withdrawn) {
                        this.$showErrorToast("このアカウントは削除されました");
                        this.is_page_init = false; // ローディング状態を終了
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                        this.is_page_init = false; // ローディング状態を終了
                    }
                });

            // プロフィールを表示できる場合のみアイコンをセット
            if (!this.is_user_suspended && !this.is_profile_restricted) {
                this.setSuibIcons();
            }
        },
        async fetchCards() {
            await axios
                .get("/api/user/common/card/get/" + this.$route.params["uid"])
                .then((response) => {
                    this.card_list = response.data.card_list.data;
                    this.card_count = response.data.card_count;

                    if (this.card_count <= 8) {
                        this.card_is_page = false;
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("カードの取得に失敗しました");
                    }
                })
                .finally(() => {
                    this.card_is_load = false;
                });
        },
        async fetchCardsMore() {
            this.card_page++;

            await axios
                .get(
                    "/api/user/common/card/get/" +
                    this.$route.params["uid"] +
                    "?page=" +
                    this.card_page
                )
                .then((response) => {
                    this.card_list.push.apply(
                        this.card_list,
                        response.data.card_list.data
                    );

                    if (response.data.card_list.data.length == 0) {
                        this.card_is_page = false;
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("カードの取得に失敗しました");
                    }
                });
        },
        async fetchUserCards() {
            await axios
                .get("/api/user/your/card/get/" + this.$route.params["uid"])
                .then((response) => {
                    this.user_card_list = response.data.user_card_list.data;
                    this.user_card_count = response.data.user_card_count;

                    if (this.user_card_count <= 8) {
                        this.user_card_is_page = false;
                    }

                    this.user_card_is_load = false;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("カードの取得に失敗しました");
                    }
                });
        },
        async fetchUserCardsMore() {
            this.user_card_page++;

            await axios
                .get(
                    "/api/user/your/card/get/" +
                    this.$route.params["uid"] +
                    "?page=" +
                    this.user_card_page
                )
                .then((response) => {
                    this.user_card_list.push.apply(
                        this.user_card_list,
                        response.data.user_card_list.data
                    );

                    if (response.data.user_card_list.data.length == 0) {
                        this.user_card_is_page = false;
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("カードの取得に失敗しました");
                    }
                });
        },
        async fetchPremiumMessage() {
            this.premiumMessage = '';

            const targetUserId = this.user && this.user.id;
            if (!targetUserId) {
                return;
            }

            try {
                const { data } = await axios.get('/api/matching/premium-message-like/list');
                const messages = Array.isArray(data?.premium_message_likes)
                    ? data.premium_message_likes
                    : [];

                const ownMessage = messages.find((message) => message?.user?.id === targetUserId);
                this.premiumMessage = ownMessage?.message || '';

                // プレミアムメッセージが存在し、未読の場合に既読処理を実行
                if (this.premiumMessage && ownMessage && !ownMessage.is_read) {
                    await this.markPremiumMessageAsRead();
                }
            } catch (error) {
                console.error('Failed to fetch premium messages', error);
            }
        },
        async markPremiumMessageAsRead() {
            // プレミアムメッセージが存在しない場合は何もしない
            if (!this.premiumMessage) {
                return;
            }

            try {
                const MATCHING_STATUS_PREMIUM_MESSAGE_LIKE = 4;
                const userId = this.$route.params["uid"];
                await axios.get(`/api/matching/view/set/${userId}/${MATCHING_STATUS_PREMIUM_MESSAGE_LIKE}`);

                // React側のキャッシュ再取得を促すためのフラグを立てる
                localStorage.setItem('premiumMessageMarkedAsRead', Date.now().toString());
            } catch (error) {
                // 既読処理の失敗はクリティカルではないため、エラーを握りつぶす
                console.error('Failed to mark premium message as read:', error);
            }
        },
        async loginUser() {
            let login_uid = "";
            await axios
                .get("/api/user/authUid/get")
                .then((response) => {
                    this.login_user = response.data.login_user;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    }
                });
        },
        async setConsts() {
            await axios.get("/api/user/consts/get").then((response) => {
                this.area_list = response.data.area_list;
                this.age_list = response.data.age_list;
                this.sex_list = response.data.sex_list;
            });
        },
        async setOptions() {
            await axios
                .get("/api/user/option/get/" + this.$route.params["uid"])
                .then((response) => {
                    this.penalty_users = response.data.penalty_users;
                    this.block_users = response.data.block_users;
                    this.matchings_look = response.data.matchings_look;
                    this.matchings_good = response.data.matchings_good;
                    this.matchings_comp = response.data.matchings_comp;
                    this.matchings_premium_message_like = response.data.matchings_premium_message_like;
                    this.is_like_resend_restricted = response.data.is_like_resend_restricted;

                    this.user_type = response.data.user_type;

                    this.is_bookmark = response.data.is_bookmark;
                    this.is_block = this.block_users == 0 ? false : true;
                    this.is_penalty = this.penalty_users == 0 ? false : true;
                });
        },
        setSuibIcons() {
            this.icon_list.splice(0, this.icon_list.length);
            this.max_tap = 0;

            this.icon_list.push(this.user.icon_url);

            if (
                this.user.sub_icon_url1 != null &&
                this.user.sub_icon_url1 != ""
            ) {
                this.icon_list.push(this.user.sub_icon_url1 + this.image_tag);
                this.max_tap++;
            } else {
                this.icon_list.push("");
            }
            if (
                this.user.sub_icon_url2 != null &&
                this.user.sub_icon_url2 != ""
            ) {
                this.icon_list.push(this.user.sub_icon_url2 + this.image_tag);
                this.max_tap++;
            } else {
                this.icon_list.push("");
            }
            if (
                this.user.sub_icon_url3 != null &&
                this.user.sub_icon_url3 != ""
            ) {
                this.icon_list.push(this.user.sub_icon_url3 + this.image_tag);
                this.max_tap++;
            } else {
                this.icon_list.push("");
            }
            if (
                this.user.sub_icon_url4 != null &&
                this.user.sub_icon_url4 != ""
            ) {
                this.icon_list.push(this.user.sub_icon_url4 + this.image_tag);
                this.max_tap++;
            } else {
                this.icon_list.push("");
            }

            this.tap = 0;
            this.main_icon = this.user.icon_url + this.image_tag;
        },
        chengeIcon(i) {
            this.tap = i;
            this.main_icon = this.icon_list[i];
        },
        prev() {
            this.tap--;

            if (this.tap < 0) {
                this.tap = this.max_tap;
            }

            this.main_icon = this.icon_list[this.tap];
        },
        next() {
            this.tap++;

            if (this.tap > this.max_tap) {
                this.tap = 0;
            }

            this.main_icon = this.icon_list[this.tap];
        },
        async setBookmark(t) {
            this.is_load = true;
            let response = await axios
                .post("/api/matching/bookmark/set", {
                    user_id_to: this.user.id,
                    type: t,
                })
                .then((response) => {
                    this.fetchUsers();
                    this.updateInformationMarkAsReadByUser();
                    this.is_menu = false;
                    this.is_page_good_message_btn = false;
                    this.is_page_good_message = false;
                    this.is_page_good = false;
                    this.is_page_look = false;
                    this.is_page_penalty = false;

                    this.is_bookmark = !this.is_bookmark;
                    this.is_bookmark_done = true;
                    setTimeout(() => {
                        this.is_bookmark_done = false;
                    }, 3000);
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("お気に入りの設定に失敗しました");
                    }
                })
                .finally(() => {
                    this.is_load = false;
                });
        },
        async setLook() {
            if (this.is_load) {
                return;
            }

            this.is_load = true;
            let response = await axios
                .post("/api/matching/look/set", {
                    user_id_to: this.user.id,
                    message: this.text_good_message,
                })
                .then((response) => {
                    this.is_load = false;
                    if (response.data.res == "420") {
                        window.location.href = "/error/look/limit";
                    } else {
                        this.fetchUsers();
                        this.updateInformationMarkAsReadByUser();
                        this.matchings_look = 1;
                        this.is_menu = false;
                        this.is_page_good_message_btn = false;
                        this.is_page_good_message = false;
                        this.is_page_good = false;
                        this.is_page_look = false;
                        this.is_page_penalty = false;
                    }
                })
                .catch((error) => {
                    this.is_load = false;
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("みてねに失敗しました");
                    }
                });
        },
        async setGood(t) {
            if (this.is_load) {
                return;
            }

            if (t == 2) {
                let ans = true;
                ans = confirm("こちらで送信してよろしいでしょうか。");

                if (!ans) {
                    return;
                }
            }

            this.is_load = true;
            let response = await axios
                .post("/api/matching/good/set", {
                    user_id_to: this.user.id,
                    source_screen: 'user_profile',
                    message: this.text_good_message,
                })
                .then((response) => {
                    window.location.href =
                        "/matching/good/" +
                        this.user.id +
                        "?type=" +
                        response.data.is_msg;
                })
                .catch((error) => {
                    this.is_load = false;
                    // いいね上限到達は 429 + error_code で返る（throttle:api の 429 と区別する）
                    if (error.response && error.response.data && error.response.data.error_code == "GOOD_LIMIT_REACHED") {
                        window.location.href = "/error/good/limit";
                    } else if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else if (error.response && error.response.status == 409) {
                        this.$showErrorToast(error.response.data.message);
                    } else {
                        this.$showErrorToast("いいねに失敗しました");
                    }
                });
        },
        async setMatching() {
            if (this.is_load) {
                return;
            }

            this.is_load = true;
            let response = await axios
                .post("/api/matching/congratulation/set", {
                    user_id_to: this.user.id,
                    message: this.text_good_message,
                })
                .then((response) => {
                    window.location.href =
                        "/matching/congratulation/" +
                        this.user.id +
                        "?mid=" +
                        response.data.matchings["id"];
                })
                .catch((error) => {
                    this.is_load = false;
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast("マッチングに失敗しました");
                    }
                })
                .finally(() => {
                    this.is_load = false;
                });
        },
        async setPenalty(p, t) {
            if (this.is_load) {
                return;
            }

            let ans = true;

            if (p == "skip") {
                ans = confirm("スキップします。よろしいですか？");
            }

            if (ans) {
                await axios
                    .post(
                        "/api/matching/penalty/" +
                        p +
                        "/" +
                        this.$route.params["uid"] +
                        "/" +
                        t +
                        "/" +
                        this.item_penalty,
                        {
                            detail_text: this.detail_text,
                        }
                    )
                    .then((response) => {
                        this.is_load = false;
                        if (t == 0) {
                            this.fetchUsers();
                            this.updateInformationMarkAsReadByUser();
                            this.is_menu = false;
                            this.is_menu = false;
                            this.is_page_good_message_btn = false;
                            this.is_page_good_message = false;
                            this.is_page_good = false;
                            this.is_page_look = false;
                            this.is_page_penalty = false;
                        } else {
                            if (p == "skip") {
                                window.location.href = "/good/list";
                            } else if (p == "block") {
                                window.location.href = "/search";
                            } else if (p == "report") {
                                window.location.href = "/search";
                            }
                        }

                        this.fileUp(response.data.pid);
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true";
                        } else {
                            this.$showErrorToast("通報に失敗しました");
                        }
                    });
            }
        },
        onChangeReason(s) {
            // 同じ項目をクリックした場合は選択解除、違う項目をクリックした場合は新しく選択
            if (this.item_penalty === s) {
                this.item_penalty = 0; // 選択解除
                this.is_page_good_message_btn = false;
            } else {
                this.item_penalty = s; // 新しく選択
                this.is_page_good_message_btn = true;
            }
        },
        // 足跡
        async setFootPrint() {
            await axios.post("/api/footprint/set", {
                uid: this.$route.params["uid"],
            });
        },
        async isAuth() {
            let response_auth = await axios.get("/api/user/is_auth");

            if (response_auth.data.is_atuh == false) {
                this.user_type = this.USER_TYPE.GUEST;
                this.prev_type = this.USER_TYPE.GUEST;
                this.login_user = [{ is_certificate: 1 }];
            }
        },
        setAuth() {
            localStorage.setItem("redirect", this.$route.path);
            window.location.href = "/auth";
        },
        async isBlock() {
            await axios
                .get("/api/user/block/check/" + this.$route.params["uid"])
                .then((response) => {
                    if (response.data.is_block) {
                        window.location.href = "/block";
                    }
                })
                .catch((error) => {
                    // 未ログイン（ゲスト閲覧）では 401 が返る。この画面はゲストでも
                    // 閲覧できるためリダイレクトはせず、ブロック判定だけを諦める。
                    if (error.response && error.response.status == 401) {
                        return;
                    }

                    console.error(error);
                });
        },
        btnclick() {
            this.$refs.input.click();
        },
        cancel() {
            this.file = null;
            this.is_load_p = true;
            this.selectedFileName = "";
            this.$refs.input.value = null;
        },
        selectedFile() {
            const image = this.$refs.input.files[0];
            if (!image) {
                return;
            }

            // ファイル名を保存
            this.selectedFileName = image.name;

            loadImage.parseMetaData(image, (data) => {
                const options = {
                    maxHeight: 512,
                    maxWidth: 512,
                    canvas: true,
                };

                if (data.exif) {
                    options.orientation = data.exif.get("Orientation");
                }
                this.displayImage(image, options);
            });

            this.is_load_p = false;
        },
        displayImage(file, options) {
            loadImage(
                file,
                async (canvas) => {
                    const data = canvas.toDataURL(file.type);

                    // data_url形式をblob objectに変換
                    const blob = this.base64ToBlob(data, file.type);
                    // objectのURLを生成
                    const url = window.URL.createObjectURL(blob);
                    this.file = blob; // resizedImgはdataで定義
                },
                options
            );
        },
        base64ToBlob(base64, fileType) {
            const bin = atob(base64.replace(/^.*,/, ""));
            const buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
                buffer[i] = bin.charCodeAt(i);
            }
            return new Blob([buffer.buffer], {
                type: fileType ? fileType : "image/png",
            });
        },
        async fileUp(id) {
            if (id == 0) {
                return;
            }

            if (this.file == null) {
                return;
            }

            let config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };

            let formData = new FormData();
            formData.append("penalty_detail_file", this.file);

            let response = await axios
                .post("/api/penalty/file/up/" + id, formData, config)
                .then((response) => { })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true";
                    } else {
                        this.$showErrorToast(
                            "ファイルのアップロードに失敗しました"
                        );
                    }
                });
        },
        async initializePageResources() {
            this.setFootPrint();
            this.isBlock();
            await this.fetchUsers();
            this.updateInformationMarkAsReadByUser();

            if (this.is_user_suspended || this.is_profile_restricted) {
                return;
            }

            this.fetchCards();
            this.fetchUserCards();
            await this.fetchPremiumMessage();
            this.loginUser();
            this.setConsts();
            this.setOptions();
            this.isAuth();

            this.initializePrevPageInfo();
        },
        getCookieValue(key) {
            if (!document.cookie) {
                return undefined;
            }

            const cookies = document.cookie.split('; ');
            for (const cookie of cookies) {
                const [cookieKey, ...valueParts] = cookie.split('=');
                if (cookieKey === key) {
                    return decodeURIComponent(valueParts.join('='));
                }
            }

            return undefined;
        },
    },
    async created() {
        const uid = this.getCookieValue('uid');

        if (!uid) {
            await this.initializePageResources();
            return;
        }

        try {
            await axios.get(`/api/user/auth/${uid}`);
            await this.initializePageResources();
        } catch (error) {
            this.$showErrorToast("ユーザーの取得に失敗しました");
        }
    },
    filters: {
        priceLocaleString(value) {
            if (value != undefined) {
                return value.toLocaleString();
            } else {
                return value;
            }
        },
        loginStatus(login_at) {
            let status = "数秒前";

            let dt = new Date();
            let lg = new Date(login_at);

            //lg.setHours(lg.getHours() + 9)

            var diff = dt.getTime() - lg.getTime();
            //分
            var minutes = Math.floor(diff / (60 * 1000));
            //時
            var hour = Math.floor(diff / (60 * 60 * 1000));
            //日
            var day = Math.floor(diff / (1000 * 60 * 60 * 24));

            if (day == 0 && hour == 0 && minutes > 0) {
                status = minutes + "分前";
            } else if (day == 0 && hour > 0) {
                status = hour + "時間前";
            } else if (day > 0 && day < 31) {
                status = day + "日前";
            } else if (day > 30) {
                status = "30日以上前";
            }

            return status;
        },
    },
    watch: {
        text_good_message: function (u) {
            this.message_count = [...u].length;
            if ([...u].length > 200) {
                this.is_set = false;
            } else {
                this.is_set = true;
            }
        },
        detail_text: function (newVal) {
            if ([...newVal].length > 400) {
                this.is_detail_text = true;
            } else {
                this.is_detail_text = false;
            }
        },
    },
};
</script>
<style>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.filter {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    filter: grayscale(100%);
}

.head-btn-box {
    color: #000;
    background: rgba(221, 221, 221, 0.527);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    font-size: 20px;
    text-align: center;
}

.side-btn {
    color: #000;
    font-size: 35px;
    background: rgba(221, 221, 221, 0.527);
    border-radius: 5px;
}

.modal-menu {
    position: absolute;
    z-index: 99999;
    top: 50px;
    right: 20px;
    padding: 10px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 1px 1px 5px 2px rgba(119, 119, 119, 0.6);
}

/* 通常のボタン色 */
.btn-look,
.btn-look.disabled,
.btn-look:disabled {
    color: #fff;
    background-color: #f3ce5e;
    border-color: #f3ce5e;
    border-radius: 50px;
    z-index: 9;
}

.btn-look-d,
.btn-look-d.disabled,
.btn-look-d:disabled {
    color: #fff;
    background-color: #bbb;
    border-color: #bbb;
    border-radius: 50px;
}

/* focusされた時の枠線の色 */
.btn-look:focus,
.btn-look.focus,
.btn-look:not(:disabled):not(.disabled):active:focus,
.btn-look:not(:disabled):not(.disabled).active:focus,
.show>.btn-look.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem #d2f0ee;
}

/* hover時（マウスカーソルを重ねた時）の色（通常より濃いor暗めの色を指定） */
.btn-look:hover {
    color: #fff;
    background-color: #f3ce5e;
    border-color: #f3ce5e;
}

/* active時の色（hover時と同等かさらに濃いor暗めの色を指定） */
.btn-look:not(:disabled):not(.disabled):active,
.btn-look:not(:disabled):not(.disabled).active,
.show>.btn-look.dropdown-toggle {
    color: #fff;
    background-color: #f3ce5e;
    border-color: #f3ce5e;
}

/* 通常のボタン色 */
.btn-look-outline,
.btn-look-outline.disa-outlinebled,
.btn-look:disabled {
    color: #f3ce5e;
    background-color: #fff;
    border-color: #f3ce5e;
    border-radius: 50px;
    z-index: 9;
}

.link_1 {
    color: #000;
}

.link_1:hover {
    color: #000;
}

.link_1:link {
    color: #000;
}

.link_1:visited {
    color: #000;
}

.type_box {
    position: relative;
    display: inline-block;
}

.type_box img {
    display: block;
    max-width: 100%;
    height: auto;
}

.type_box img.type_icon {
    position: absolute;
    width: 10%;
    height: auto;
}

.type_box img.type_icon_big {
    position: absolute;
    width: 32%;
    height: auto;
}

.type_box img.type_icon_out {
    position: absolute;
    width: 25%;
    height: auto;
}

.img-main-luna {
    filter: drop-shadow(0px 0px 24px rgba(0, 0, 0, 0.15));
    border-radius: 20px;
}

.item-box {
    overflow: hidden;
    padding: 15px 20px;
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
}

.item-line-on {
    float: left;
    margin-right: 2px;
    margin-bottom: 2px;
    border-radius: 20px;
    padding: 3px 10px;
    color: #fff;
    font-size: 11px;
    background-color: #9990ff;
}

.item-line-off {
    float: left;
    margin-right: 2px;
    margin-bottom: 2px;
    border-radius: 20px;
    padding: 3px 10px;
    color: #cdcdcd;
    font-size: 11px;
    background-color: #f2f2f2;
}

.luna-rounded {
    border-radius: 20px;
}

.comment-top {
    position: relative;
    display: inline-block;
    margin: 1.5em 0;
    padding: 24px 22px;
    min-width: 100%;
    max-width: 100%;
    color: #5538ee;
    font-size: 16px;
    background: #e7e7ff;
    white-space: pre-wrap;
}

.comment-top:before {
    content: "";
    position: absolute;
    top: -30px;
    left: 50%;
    margin-left: -10px;
    border: 10px solid transparent;
    border-bottom: 30px solid #e7e7ff;
}

.comment-bubble {
    position: relative;
    background-color: #e7e7ff;
    padding: 20px;
    margin-top: 10px;
    border-radius: 10px;
    color: #5538ee;
    line-height: 1.5;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 吹き出しの尖った部分 */
.comment-bubble::before {
    content: "";
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent #e7e7ff transparent;
}

/* TODO: グローバルに変更すると影響が怖いのでShowだけ別で作成。リプレイスの際にはグローバルに変更してください */
.luna-footer-menu-show {
    position: fixed;
    bottom: 0;
    max-width: 540px;
    min-height: 80px;
    background-color: #fff;
    padding: 15px;
    z-index: 99999;
}
</style>

<style scoped>
.card-body {
    padding: 0;
}

.card-subject {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-bottom: 1px solid #e4e4e6;
}

.card-subject-close {
    position: absolute;
    left: 0;
    padding: 0 8px;
    font-size: 24px;
    cursor: pointer;
}

.card-subject-text {
    margin: 0;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
}

.card-content {
    max-height: calc(100vh - 192px);
    padding: 16px;
    overflow: auto;
}

.card-footer {
    background-color: #fff;
}

@media (min-height: 791px) {
    .card-footer {
        border-top: 0;
    }
}

.reason-item {
    text-align: center;
    cursor: pointer;
    padding: 12px 16px;
    margin: 8px 0;
    border: 1px solid #d4d3d8;
    border-radius: 12px;
    background-color: #fff;
    color: #333;
    font-size: 14px;
    font-weight: normal;
    transition: all 0.3s ease;
}

.reason-item.active {
    color: #5538ee;
    font-weight: bold;
    border: 2px solid #5538ee;
    background-color: rgba(0, 123, 255, 0.1);
}

.reason-item:hover {
    background-color: #e9ecef;
}

.reason-item.active:hover {
    background-color: rgba(0, 123, 255, 0.2);
}

.textarea-container {
    position: relative;
    margin-bottom: 0;
    border: 1px solid #d4d3d8;
    border-radius: 12px;
}

.textarea-container.active {
    border: 2px solid #5538ee;
    outline: none;
}

.textarea-wrapper {
    position: relative;
    padding-top: 32px;
    padding-bottom: 32px;
    overflow: hidden;
}

.floating-label {
    position: absolute;
    left: 12px;
    top: 14px;
    color: #999;
    font-size: 14px;
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 1;
    background: transparent;
    padding: 0 4px;
    border-radius: 4px;
}

.floating-label.active {
    top: 12px;
    left: 8px;
    font-size: 10px;
    color: #5538ee;
}

.reason-detail {
    position: relative;
    display: inline-block;
    font-size: 14px;
    transition: border-color 0.3s ease;
    background: #fff;
    z-index: 0;
    box-sizing: border-box;
}

.char-counter {
    position: absolute;
    right: 12px;
    bottom: 8px;
    font-size: 12px;
    color: #999;
    background: white;
    padding: 0 4px;
    border-radius: 4px;
}

.select-file {
    display: flex;
    align-items: center;
    margin-top: 16px;
}

.btn-select-file {
    padding: 12px;
    border-radius: 12px;
    border: 1px solid #d4d3d8;
    font-size: 14px;
    font-weight: bold;
}

.select-file-description {
    margin: 0 0 0 8px;
    color: #717179;
    font-size: 12px;
}

.selected-file-info {
    margin-top: 16px;
    color: #09090b;
    font-size: 14px;
    word-break: break-all;
}

.delete-file {
    margin: 0;
    color: #ff001f;
    font-size: 14px;
    cursor: pointer;
}

.btn-report-wrapper {
    display: flex;
    justify-content: center;
}

.btn-report {
    width: 273px;
    padding: 12px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 12px;
}

/* 通報モーダルのスクロール対応 */
.report-modal-container {
    min-height: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
    width: 100%;
}

.report-modal-card {
    margin: 0 !important;
}

/* 小さい画面用の最適化 */
@media (max-height: 900px) {
    .card-footer {
        position: relative;
    }

    .card-footer::before {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 0;
        right: 0;
        height: 20px;
        background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
        pointer-events: none;
    }
}

/* iPhone 17など小さい画面向けの追加最適化 */
@media (max-height: 875px) {
    .reason-item {
        padding: 10px 14px;
        margin: 6px 0;
        font-size: 13px;
    }

    .textarea-wrapper {
        padding-top: 28px;
        padding-bottom: 28px;
    }

    .btn-report {
        padding: 10px;
        font-size: 15px;
    }

    .report-modal-container {
        padding: 10px 0;
    }
}

/* さらに小さい画面（横向きなど） */
@media (max-height: 700px) {
    .reason-item {
        padding: 8px 12px;
        margin: 4px 0;
        font-size: 12px;
    }

    .card-subject-text {
        font-size: 16px;
    }

    .textarea-wrapper {
        padding-top: 24px;
        padding-bottom: 24px;
    }
}

.suspended-container {
    padding: 36px 16px;
}

.suspended-image {
    margin-bottom: 16px;
}

.suspended-heading {
    margin-bottom: 16px;
    font-size: 24px;
    color: #09090b;
}

.suspended-reason {
    font-size: 12px;
    color: #09090b;
}

/**
 * プレミアムメッセージ
 */
.premium-message {
    position: relative;
    padding: 16px;
    margin-top: 24px;
    background-color: #4f3f81;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
    border-radius: 16px;
}

.premium-message::before {
    position: absolute;
    content: '';
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 20px 10px;
    border-style: solid;
    border-color: transparent transparent #4f3f81 transparent;
}

/**
 * いいね
 */
.send-good-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .29);
    z-index: 999999;
}

.send-good-modal-overlay.hide-modal-overlay {
    background: transparent;
}

.send-good-half-modal {
    position: fixed;
    left: 50%;
    bottom: 0;
    max-width: 540px;
    width: 100%;
    background-color: #f7f7f8;
    transform: translate(-50%);
    border-radius: 20px 20px 0 0;
}

.close-modal {
    position: absolute;
    top: 4px;
    left: 12px;
    font-size: 24px;
    cursor: pointer;
}

.send-good-heading {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin: 24px 16px 0;
}

.send-good-heading>.send-good-heading-text {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
}

.send-good-heading>img {
    width: 120px;
}

.send-premium-message {
    position: relative;
    margin: 16px;
}

.limited-premium-message {
    width: 100%;
    height: calc(100% - 16px);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    cursor: not-allowed;
}

.send-premium-message-button {
    margin-bottom: 4px;
    background: #4f3f81;
    border: 0;
    border-radius: 10px;
    cursor: pointer;
    transition: .4s;
}

.send-premium-message-button.disabled {
    opacity: .2;
    cursor: not-allowed;
}

.send-premium-message-button.disabled:hover {
    opacity: .2;
}

.send-premium-message-button:hover {
    opacity: .9;
    transition: .4s;
}

.send-premium-message-button img {
    width: 100%;
}

.send-premium-message-image-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
}

.event-badge-overlay {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 4px 8px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
}

.send-premium-message-resume-button-wrapper {
    position: fixed;
    top: 8px;
    left: 50%;
    width: 100%;
    max-width: 540px;
    transform: translateX(-50%);
    z-index: 1000000;
}

.send-premium-message-resume-button {
    position: absolute;
    top: 64px;
    right: 16px;
    width: 140px;
    padding: 12px 0;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    background: #4f3f81;
    border: 1px solid #dadadd;
    border-radius: 12px;
}

.sent-premium-message-button {
    padding: 12px;
    background-color: #4f3f81;
    color: #fff;
    opacity: .8;
    cursor: not-allowed;
}

.rest-of-message {
    font-size: 11px;
    font-weight: 700;
    line-height: 1.5;
    text-align: right;
}

.rest-of-message.rest-of-message-good {
    color: #5538ee;
}

.send-good-button {
    width: 100%;
    padding: 16px 0;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 700;
    border: 0;
    border-radius: 10px;
}

.send-good-button.disabled {
    background: #dadadd;
    color: #94939d;
    cursor: not-allowed;
}

.send-good-button--fill {
    background: #5538ee;
    color: #fff;
}

.send-good-button--outline {
    background: #fff;
    color: #5538ee;
    border: 1px solid #dadadd;
}

.send-good-with-message {
    margin: 0 16px;
}

.send-good-with-message-note {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.send-good-with-message-note>.send-good-with-message-note-text {
    color: #5538ee;
    font-size: 10px;
}

.send-good {
    margin: 16px;
}
</style>
